export type Universe = 'neutral' | 'app' | 'dossier';
export type Role = 'intro1' | 'intro2' | 'e1' | 'e2' | 'e3' | 'concl' | null;
export type Kind = 'cover' | 'intro' | 'plan' | 'axis1' | 'app' | 'axis2' | 'piece' | 'verdict' | 'sources' | 'merci';

export interface SlideDef {
  id: string;
  n: number;
  kind: Kind;
  universe: Universe;
  role: Role;
  budget: number;
  label: string;
  part?: string;
  idx?: number;
}

export const SLIDES: SlideDef[] = [
  { id: 's1', n: 1, kind: 'cover', universe: 'neutral', role: null, budget: 10, label: 'Couverture' },
  { id: 's2', n: 2, kind: 'intro', universe: 'neutral', role: 'intro1', budget: 75, label: 'Introduction' },
  { id: 's3', n: 3, kind: 'plan', universe: 'neutral', role: 'intro2', budget: 75, label: 'Problématique & plan' },
  { id: 's4', n: 4, kind: 'axis1', universe: 'app', role: null, budget: 10, label: 'Ouverture axe I' },
  { id: 's5', n: 5, kind: 'app', universe: 'app', role: 'e1', budget: 105, label: 'I.A', part: 'I.A', idx: 0 },
  { id: 's6', n: 6, kind: 'app', universe: 'app', role: 'e2', budget: 105, label: 'I.B', part: 'I.B', idx: 1 },
  { id: 's7', n: 7, kind: 'app', universe: 'app', role: 'e3', budget: 105, label: 'I.C', part: 'I.C', idx: 2 },
  { id: 's8', n: 8, kind: 'axis2', universe: 'dossier', role: null, budget: 10, label: 'Ouverture axe II' },
  { id: 's9', n: 9, kind: 'piece', universe: 'dossier', role: 'e1', budget: 105, label: 'II.A', part: 'II.A', idx: 3 },
  { id: 's10', n: 10, kind: 'piece', universe: 'dossier', role: 'e2', budget: 105, label: 'II.B', part: 'II.B', idx: 4 },
  { id: 's11', n: 11, kind: 'piece', universe: 'dossier', role: 'e3', budget: 105, label: 'II.C', part: 'II.C', idx: 5 },
  { id: 's12', n: 12, kind: 'verdict', universe: 'neutral', role: 'concl', budget: 90, label: 'Conclusion — verdict' },
  { id: 's13', n: 13, kind: 'sources', universe: 'neutral', role: null, budget: 0, label: 'Sources' },
  { id: 's14', n: 14, kind: 'merci', universe: 'neutral', role: null, budget: 0, label: 'Merci / Questions' },
];

export const SUBPARTS = SLIDES.filter((s) => s.part);
export const TOTAL_BUDGET = 900;

export const TAGS = [
  { id: 'travail', label: 'Travail' },
  { id: 'juridique', label: 'Juridique' },
  { id: 'financier', label: 'Financier' },
];

export interface Team { names: string[]; intro1: number; intro2: number }
export const DEFAULT_TEAM: Team = { names: ['', '', ''], intro1: 0, intro2: 1 };

export interface Example { id: string; name: string; main?: boolean }
export const DEFAULT_EXAMPLES: Example[] = [
  { id: 'uber', name: 'Uber', main: true },
  { id: 'deliveroo', name: 'Deliveroo' },
  { id: 'airbnb', name: 'Airbnb' },
];

export const conclIndex = (t: Team) => [0, 1, 2].find((i) => i !== t.intro1 && i !== t.intro2) ?? 2;

export function speakerOf(role: Role, t: Team): number | null {
  if (!role) return null;
  if (role === 'intro1') return t.intro1;
  if (role === 'intro2') return t.intro2;
  if (role === 'concl') return conclIndex(t);
  return Number(role.slice(1)) - 1;
}

export const nameOf = (i: number | null, t: Team) => (i === null ? '—' : t.names[i]?.trim() || `Élève ${i + 1}`);

export const ROLE_LABEL: Record<string, string> = {
  intro1: 'Intro — partie 1', intro2: 'Intro — partie 2', e1: 'Élève 1', e2: 'Élève 2', e3: 'Élève 3', concl: 'Conclusion',
};

export function coverage(get: (k: string) => any) {
  const c: Record<string, number> = { travail: 0, juridique: 0, financier: 0 };
  SUBPARTS.forEach((s) => ((get(`${s.id}:tags`) as string[]) || []).forEach((t) => { if (t in c) c[t]++; }));
  return c;
}

export const fmt = (sec: number) => {
  const s = Math.max(0, Math.floor(sec));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
};

export const level = (spent: number, budget: number) => (!budget ? 'none' : spent > budget ? 'over' : spent >= budget * 0.8 ? 'warn' : 'ok');
